import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Footer from "../Footer/Footer";
import { useEffect } from "react";
// import VideoBg from "../../assets/image/Term&Condition/bg-video.gif";

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  return (
    <>
      {/* Accordion */}
      <div className="container my-5">
        <div className="row">
          <h3 className="text-center display-5 fw-bold">
            Terms & <span className="font-red">Conditions</span>
          </h3>
        </div>
      </div>

      <div className="container-fluid bg-light">
        <p className="fs-5 fw-medium text-center pt-4 px-2">
          Welcome to <span className="font-red fw-bold">SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED</span>. These
          terms and conditions outline the rules and regulations for
          <br />
          the use of our services, including Drone Technology, AI solutions,
          IoT systems, Robotics, and digital platforms.
        </p>

        <div className="container py-5">
          <div className="row align-items-center">
            {/* Accordion content */}
            <Accordion defaultActiveKey="0" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    1. Acceptance of Terms
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  By accessing or using our services, you agree to be bound by
                  these terms. If you do not agree with any part of the terms,
                  please do not use our services.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    2. Services Offered
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED provides a wide range of services, including
                  Drone Technology solutions, Artificial Intelligence (AI), Internet of Things (IoT),
                  Robotics development, software solutions, and digital platforms.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    3. Intellectual Property
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  All content, graphics , applications, systems, and solutions developed by SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED are the intellectual property of the company.
                  Unauthorized use, reproduction, or distribution is strictly
                  prohibited.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    4. User Responsibilities
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  You are responsible for maintaining the confidentiality of any
                  login credentials and for all activities under your account.
                  You agree not to misuse our platforms or services in any
                  manner.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    5. Limitation of Liability
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED is not liable for any damages that may arise from
                  the use or inability to use our services, including direct, indirect,
                  incidental, or consequential damages.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    6. Changes to Terms
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  We may revise these terms and conditions at any time without
                  prior notice. By continuing to use our services, you agree to
                  the updated terms.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="7" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    7. Governing Law
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  These terms shall be governed and interpreted in accordance
                  with the laws of India. Any disputes will be subject to the
                  jurisdiction of the courts in Tamil Nadu.
                </Accordion.Body>
              </Accordion.Item>

              {/* <Accordion.Item eventKey="8" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    8. Limitation of Liability
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED shall not be liable for any indirect, incidental,
                  or consequential damages resulting from the use of our
                  services.
                </Accordion.Body>
              </Accordion.Item>
             */}
              <Accordion.Item eventKey="8" className="mt-3">
                <Accordion.Header>
                  <span className="font-black fw-bold fs-4">
                    8. Data & Technology Usage
                  </span>
                </Accordion.Header>
                <Accordion.Body className="font-para">
                  Our services may involve the use of advanced technologies such as drones,
                  AI systems, and IoT devices. Users agree to use these technologies responsibly
                  and in compliance with applicable laws and regulations.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <Footer />

      {/* <div className="container-fluid bg-light py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-4 text-dark">Contact Information</h2>

          <p className="mb-2 fw-medium text-secondary">
            <strong>Office Location:</strong>
            <br />
            No. 48, 2nd Floor, Lotus Castle, First Main Rd, Radha Nagar,
            <br />
            Perumbakkam, Chennai, Tamil Nadu 600100
          </p>

          <p className="mb-1">📞 +91 99529 84636</p>
          <p className="mb-1">📞 +91 81228 25676</p>
          <p className="mb-3">📞 +91 81228 25676</p>

          <p className="fs-5 fw-semibold">
            📧{" "}
            <a
              href="mailto:info@theshivgames.com"
              className="text-danger text-decoration-none"
            >
              info@theshivgames.com
            </a>
          </p>
        </div>
      </div> */}
    </>
  );
};

export default TermsConditions;
